import { Component, ViewEncapsulation } from '@angular/core';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'ds-form-grid',
  templateUrl: './form-grid.component.html',
  styleUrls: ['./form-grid.component.scss'],
  imports: [CommonModule],
  encapsulation: ViewEncapsulation.None,
})
export class FormGridComponent {}
